import { render, staticRenderFns } from "./YourFavourites.vue?vue&type=template&id=40e30196&scoped=true&"
import script from "./YourFavourites.vue?vue&type=script&lang=js&"
export * from "./YourFavourites.vue?vue&type=script&lang=js&"
import style0 from "./YourFavourites.vue?vue&type=style&index=0&id=40e30196&lang=scss&scoped=true&"
import style1 from "./YourFavourites.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e30196",
  null
  
)

export default component.exports